import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

import LayoutContent from '@/components/LayoutContent'

const SchemaLoader = () => {
  return (
    <LayoutContent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <CircularProgress />
      </Box>
    </LayoutContent>
  )
}

export default SchemaLoader
